export default "__VITE_ASSET__CglE8Mi1__"